module.exports = __webpack_public_path__ + "img/icon-pago-efectivo.4e19752b.svg";